export default {"src":"/_next/static/media/img-filecsv2.008e3fd7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};